import { render, staticRenderFns } from "./AAuditItemTypeSelect.vue?vue&type=template&id=1f7a444c&"
import script from "./AAuditItemTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./AAuditItemTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
